import { useState } from "react";
import { Camera, X } from "lucide-react";
import PageHeader from "../components/site/PageHeader";

const PHOTOS = [
  { id: 1, src: "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=1200&q=80", title: "Atletik Performans" },
  { id: 2, src: "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=1200&q=80", title: "Spor Salonu" },
  { id: 3, src: "https://images.unsplash.com/photo-1599058917212-d750089bc07e?w=1200&q=80", title: "Boks Antrenmanı" },
  { id: 4, src: "https://images.unsplash.com/photo-1551958219-acbc608c6377?w=1200&q=80", title: "Fitness" },
  { id: 5, src: "https://images.unsplash.com/photo-1574680096145-d05b474e2155?w=1200&q=80", title: "Tenis Kortu" },
  { id: 6, src: "https://images.unsplash.com/photo-1518604666860-9ed391f76460?w=1200&q=80", title: "Yüzme" },
  { id: 7, src: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1200&q=80", title: "Basketbol" },
  { id: 8, src: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?w=1200&q=80", title: "Voleybol" },
  { id: 9, src: "https://images.unsplash.com/photo-1556817411-31ae72fa3ea0?w=1200&q=80", title: "Pilates" },
];

export default function Gallery() {
  const [active, setActive] = useState(null);
  return (
    <div data-testid="gallery-page">
      <PageHeader
        eyebrow="Galeri"
        title="Sahanın İçinden"
        subtitle="Antrenmanlar, etkinlikler ve kulüp anıları — Focus Spor Kulübü dünyasından kareler."
      />

      <section className="section-pad">
        <div className="container-x">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {PHOTOS.map((p) => (
              <button
                key={p.id}
                type="button"
                onClick={() => setActive(p)}
                data-testid={`gallery-item-${p.id}`}
                className="group relative aspect-square overflow-hidden rounded-lg border border-border"
              >
                <img src={p.src} alt={p.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/30 to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-3 left-4 right-4 flex items-center gap-2 text-left">
                  <Camera className="h-3.5 w-3.5 text-primary" />
                  <span className="font-display text-sm font-bold uppercase tracking-wider">{p.title}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-[60] bg-background/95 backdrop-blur-md flex items-center justify-center p-5"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button
            type="button"
            className="absolute top-5 right-5 h-11 w-11 rounded-full bg-secondary border border-border flex items-center justify-center hover:border-primary hover:text-primary"
            onClick={() => setActive(null)}
            aria-label="Kapat"
            data-testid="gallery-close"
          >
            <X className="h-5 w-5" />
          </button>
          <img src={active.src} alt={active.title} className="max-w-full max-h-[85vh] object-contain rounded-lg border border-border" />
        </div>
      )}
    </div>
  );
}
